import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter, withHashLocation } from '@angular/router';

import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { inFlightGetInterceptor } from './interceptors/in-flight-get.interceptor';
import { requestTraceInterceptor } from './interceptors/request-trace.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes,withHashLocation()),
    provideHttpClient(withInterceptors([inFlightGetInterceptor, requestTraceInterceptor]))
  ]
};
